/** True when onboarding API payload belongs to the selected project. */
export function isOnboardingResponseForProject(response, projectId) {
  if (!response) return false;
  if (projectId == null) return true;

  const responseProjectId = response?.data?.projectId ?? response?.data?.project_id;
  if (responseProjectId == null) return true;

  return Number(responseProjectId) === Number(projectId);
}

/** Show loading until fetch settles for the selected project — never show mismatched data. */
export function isProgressionDataLoading({ isPending, isFetching, response, projectId }) {
  if (projectId == null) {
    return isPending;
  }

  if (isPending || !response) {
    return isPending || isFetching;
  }

  if (!isOnboardingResponseForProject(response, projectId)) {
    return true;
  }

  return false;
}

/** Shared React Query options for progression/onboarding fetches. */
export const progressionQueryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
};
